import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

const AccountIcon = (props) => (
  <SvgIcon {...props}>
		<g>
			<g>
				
					<circle fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" cx="12" cy="12" r="2.423"/>
			</g>
			<path fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
				M21,13.298v-2.596l-1.896-0.237c-0.187-0.868-0.53-1.677-0.997-2.4l1.175-1.511l-1.836-1.836l-1.511,1.175
				c-0.723-0.467-1.531-0.81-2.4-0.997L13.298,3h-2.596l-0.237,1.896c-0.868,0.187-1.677,0.53-2.4,0.997L6.554,4.718L4.718,6.554
				l1.175,1.511c-0.467,0.723-0.81,1.531-0.997,2.4L3,10.702v2.596l1.896,0.237c0.187,0.868,0.53,1.677,0.997,2.4l-1.175,1.511
				l1.836,1.836l1.511-1.175c0.723,0.467,1.531,0.81,2.4,0.997L10.702,21h2.596l0.237-1.896c0.868-0.187,1.677-0.53,2.4-0.997
				l1.511,1.175l1.836-1.836l-1.175-1.511c0.467-0.723,0.81-1.531,0.997-2.4L21,13.298z"/>
		</g>
  </SvgIcon>
);

export default AccountIcon;



// WEBPACK FOOTER //
// ./src/icons/menu/AccountIcon.jsx